/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Delete_TitleInputs */

const cs_property_ai_delete_title = /** @type {(inputs: Property_Ai_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat AI návrh`)
};

const en_property_ai_delete_title = /** @type {(inputs: Property_Ai_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete AI draft`)
};

/**
* | output |
* | --- |
* | "Delete AI draft" |
*
* @param {Property_Ai_Delete_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_delete_title = /** @type {((inputs?: Property_Ai_Delete_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Delete_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_delete_title(inputs)
	return cs_property_ai_delete_title(inputs)
});